import type { User } from '@/types'
import { getAuthData } from './persistence'
import { TOKEN_EXPIRY_BUFFER_MS } from './types'

export { clearAuthData, getAuthData, storeAuthData, updateStoredUser } from './persistence'

export function isTokenExpired(): boolean {
  const authData = getAuthData()
  if (!authData?.expiresAt) {
    return true
  }
  return Date.now() >= authData.expiresAt - TOKEN_EXPIRY_BUFFER_MS
}

export function getCurrentUser(): User | null {
  return getAuthData()?.user ?? null
}

export function getAuthToken(): string | null {
  return getAuthData()?.token ?? null
}

export function isAuthenticated(): boolean {
  const authData = getAuthData()
  if (!authData?.token) {
    return false
  }
  return !isTokenExpired()
}

export function isAdmin(): boolean {
  return getCurrentUser()?.role === 'admin'
}
